import React from "react";
import { Header } from "./components/header";
import "./App.css";

const App = () => {
  return (
    <div>
      <Header />
      <h2 style={{ textAlign: "center", padding: "60px 20px" }}>
        OLEMME TAUOLLA.
      </h2>
    </div>
  );
};

export default App;
